/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const SECTION_MAPPING = {
  money: {
    "Revenue & Opex Analysis (Monthly)": "rev_and_opex_charts",
    "Money Peerview Metrics": "peerview_charts",
    "Profit & Loss": "pnl",
    "Balance Sheet": "balance_sheet",
    "Cash Flow": "cash_flow",
    "KFI's": "kfis",
  },
  people: {
    "People Peerview Metrics": "people_peerview_charts",
    "People Financial Detail": "people_financial_detail",
    "People KPI": "people_kpi",
  },
  customers: {
    "Customers Peerview Metrics": "customers_peerview_charts",
    "Customers Financial Detail": "customers_financial_detail",
    "Customers KPI": "customers_kpi",
  },
  default: {
    "Peerview Metrics": "peerview_charts",
    "Profit & Loss": "pnl",
    "Balance Sheet": "balance_sheet",
    "Cash Flow": "cash_flow",
    "KFI's": "kfis",
    "Financial Detail": "financial_detail",
    "KPI": "kpi",
  },
};

const EditParentChildDashboard = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [formMetrics, setFormMetrics] = useState(props.editDashboard);
  const [checkedItems, setCheckedItems] = useState([]);
  const modalScrollRef = useRef(null);
  const scrollYRef = useRef(0);
  
  const mapChildrenArr = (sections, metricsMapping, allMetrics) => {
    return sections.map((s) => ({
      ...s, // Preserve `showDropdown` and other properties
      childrenArr: allMetrics[metricsMapping[s.sectionName]] || [],
    }));
  };

  useEffect(() => {
    setFormMetrics((prevState) => {
      if (props.page === 'money') {
        return {
          'money': mapChildrenArr(props.editDashboard['money'], SECTION_MAPPING['money'], props.allMetrics),
          'people': mapChildrenArr(props.editDashboard['people'], SECTION_MAPPING['people'], props.allMetrics),
          'customers': mapChildrenArr(props.editDashboard['customers'], SECTION_MAPPING['customers'], props.allMetrics),
        };
      } else {
        return mapChildrenArr(props.editDashboard, SECTION_MAPPING[props.page], props.allMetrics);
      }

    });

    const container = modalScrollRef?.current;
    if (container) {
      container.scrollTop = scrollYRef?.current || 0;
    }

  }, [props.editDashboard, props.page, props.allMetrics]);

  const handleScroll = (e) => {
    scrollYRef.current = e.target.scrollTop
  };

  const openModal = () => {
    setIsOpen(true);
  }

  const closeModal = () => {
    setIsOpen(false);
  };

  const Checkbox = (props) => {
    let itemName = ''
    let padding = '';
    if (props.parent) {
      itemName = props.chart['copy'] ? props.chart['copy'] : props.chart['key']
      let relatedKey = props.chart.relatedCheckedKey || props.parent.key
      if (itemName === "Total Revenue Growth Rate Chart") {
        itemName = "Revenue Growth Rate Chart"
      }

      return (
        <div className='dashboard-form-check'>
          <label className='dashboard-form-check-label'>
            <input
              type='checkbox'
              checked={props.chart.checked}
              onChange={() => props.handleSelectAndLayout(props.page, props.sectionData['sheet'], relatedKey, props.chart.key, props.report)}
              className='form-check-input'
            />
            <span>{itemName}</span>
          </label>
        </div>
      )
    } else {
      itemName = props.chart['copy'] ? props.chart['copy'] : props.chart['key']
      if (!itemName.includes(':') && props.addColon) { itemName += ': ' }
      padding = props.chart['padding']
      return (
        <div className='dashboard-form-check'>
          <label className='dashboard-form-check-label'>
            <span>{padding}</span>
            {props.chart.displayChart
              ? (<input
                type='checkbox'
                checked={props.chart.checked}
                onChange={() => props.handleSelectAndLayout(props.page, props.sectionData['sheet'], props.chart.relatedCheckedKey, '', props.report)}
                className='form-check-input'
              />)
              : null}
            <span className='item-name'>{itemName}</span>
          </label>
        </div>
      )
    }

  }

  const buildChildren = (sectionData, report = null) => {
    let children = sectionData['childrenArr']
    return children.map((c, i) => {
      if (c['layout']) {
        return (
          <div className='checkbox-with-children' key={`${c.key}-${i}`}>
            <Checkbox key={`${c.key}-${i}-check`} addColon={true} sectionData={sectionData} chart={c} handleSelectAndLayout={props.handleSelectAndLayout} page={props.page} report={report} />
            <div key={`${c.key}-${i}-children-checks-container`} className='children-checks-container'>
              {
                c['layout'].map(l => {
                  return <Checkbox key={l.key + '-check'} sectionData={sectionData} chart={l} parent={c} handleSelectAndLayout={props.handleSelectAndLayout} page={props.page} report={report} />
                })
              }
            </div>
          </div>)
      } else {
        return (
          <div className='checkbox-with-children' key={`${c.key}-${i}`}>
            <Checkbox key={`${c.key}-${i}-check`} sectionData={sectionData} chart={c} handleSelectAndLayout={props.handleSelectAndLayout} page={props.page} report={report} />
          </div>
        )
      }
    })
  }

  const buildForm = (report = null) => {
    if (report) {
      return formMetrics[report].map(section => {
        return <Dropdown key={`dropdown-${section['sheet']}`} report={report} sectionData={section} />
      })
    } else {
      return formMetrics.map(section => {
        return <Dropdown key={`dropdown-${section['sheet']}`} report={null} sectionData={section} />
      })
    }
  }

  const Dropdown = ({ sectionData, report }) => {
    let styleType = report ? report : props.page
    let styleClassParent = styleType === 'money' ? 'dropdown-parent-money' : styleType === 'people' ? 'dropdown-parent-people' : 'dropdown-parent-customers'
    let styleClassChildren = styleType === 'money' ? 'dropdown-children-money' : styleType === 'people' ? 'dropdown-children-people' : 'dropdown-children-customers'
    styleClassChildren = sectionData['showDropdown'] ? styleClassChildren += ' dropdown-display' : styleClassChildren += ' dropdown-no-display'
    return (
      <div>
        <div className={styleClassParent} onClick={() => props.handleEditDashBoard(sectionData['sheet'], report)}>
          <span className='edit-dropdown-section-name'>{sectionData['sectionName']}</span>
          {sectionData['showDropdown'] ? <FontAwesomeIcon key={`${sectionData.sheet}-chevup`} icon={faChevronUp} /> : <FontAwesomeIcon key={`${sectionData.sheet}-chevdown`} icon={faChevronDown} />}
        </div>
        {sectionData['showDropdown'] ?
          <div className={styleClassChildren}>
            {buildChildren(sectionData, report)}
          </div> : null}
      </div>
    );
  }

  return (
    <>
      <div className='edit-dashboard-btn' onClick={openModal}>
        <i className='fa fa-bar-chart' aria-hidden='true'></i>
      </div>
      <Modal
        className={{
          base: 'dashboard-modal-content hide-on-print',
          afterOpen: 'dashboard-modal-content_after-open hide-on-print',
          beforeClose: 'dashboard-modal-content_before-close hide-on-print',
        }}
        overlayClassName={{
          base: 'dashboard-overlay-base hide-on-print',
          afterOpen: 'dashboard-overlay-base_after-open hide-on-print',
          beforeClose: 'dashboard-overlay-base_before-close hide-on-print',
        }}
        ariaHideApp={false}
        closeTimeoutMS={0}
        contentLabel='Edit Dashboard Modal'
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        shouldFocusAfterRender={false}
        shouldCloseOnOverlayClick={true}
        preventScroll={true}
      >
        <div ref={modalScrollRef} onScroll={handleScroll} className="modal-scroll-container">
          <h3>Select Charts to Display on Dashboard</h3>
          <p>Click Anywhere Outside of this Pop-up to Close</p>
          {props.editorPage && <p><span>Current Chart of Accounts:</span> {`${props.naicsForm.naics_code} - ${props.naicsForm.naics_name}`}</p>}
          <form id='parent-child-dashboard-form' onSubmit={(e) => props.handleEditMetrics(e, true)}>
            <div className='dashboard-form-btn-section'>
              {props.allMetrics.noChangesMade ? null : <button className='btn dashboard-save-btn'>Save Changes</button>}
            </div>
            {props.page !== 'money'
              ? buildForm()
              : <>
                {buildForm('money')}
                {buildForm('people')}
                {buildForm('customers')}
              </>
            }
          </form>
        </div>
      </Modal>
    </>
  )
}
export default EditParentChildDashboard;